import { rem, Skeleton } from '@mantine/core';
import { HoldingsSummary } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/HoldingsSummaryCard/HoldingsSummary.tsx';
import { getHoldingsTotals } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/HoldingsSummaryCard/holdingsSummary.utils.ts';
import { useVehicleValuations } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestmentVehicleDetails/useVehicleValuations.ts';

interface Props {
	personId: string;
}

export const VehicleHoldingsSummaryCard = ({ personId }: Props) => {
	const { valuations, isLoading, isError } = useVehicleValuations({ personId });

	if (isLoading) {
		return <Skeleton height={rem(100)} radius="0.5rem" />;
	}

	return (
		<HoldingsSummary
			totals={getHoldingsTotals(valuations)}
			currency={valuations?.currency}
			isError={isError}
			showLoan={!!valuations?.loans.length}
		/>
	);
};
